export default __webpack_public_path__ + "static/photon_bulb_lit-7d764e2e2140bd2e1d4c3359111871ac.svg";